export default __webpack_public_path__ + "static/media/menu.9009cbc2.svg";